import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'
import { Account } from '@/utils/config'

export function getBeefCutsCRM(params) {
  return request({
    url: '/GetBeefCutsCRM',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 901,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Keywords: params.Keywords
      }
    }
  })
}

export function importBeefCutsCRM(params) {
  const formData = new FormData()
  formData.append('MessageType', 902)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportBeefCutsCRM',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getBeefCutsContent(params) {
  return request({
    url: '/GetBeefCutsContent',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 903,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Origin: params.Origin,
        Company: params.Company,
        EstNo: params.EstNo,
        Cuts: params.Cuts
      }
    }
  })
}

export function importBeefCutsResearch(params) {
  const formData = new FormData()
  formData.append('MessageType', 904)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportBeefCutsResearch',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function addBeefCutsContent(params) {
  return request({
    url: '/AddBeefCutsContent',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 905,
      MessageID: btcguid(),
      Data: {
        Origin: params.Origin,
        EstNo: params.EstNo,
        Cuts: params.Cuts,
        Content: params.Content
      }
    }
  })
}

export function backendPublishCutsComment(params) {
  return request({
    url: '/BackendPublishCutsComment',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 906,
      MessageID: btcguid(),
      Data: {
        Origin: params.Origin,
        Company: params.Company,
        EstNo: params.EstNo,
        Cuts: params.Cuts,
        Content: params.Content,
        UserID: Account,
        CutsCode: params.CutsCode,
        EstNoCode: params.EstNoCode
      }
    }
  })
}

export function backendUploadEstBrochure(params) {
  const formData = new FormData()
  formData.append('MessageType', 907)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('Origin', params.Origin)
  formData.append('EstNo', params.EstNo)
  formData.append('Company', params.Company)
  formData.append('UserID', Account)
  formData.append('IsAnonymous', true)
  formData.append('EstNoCode', params.EstNoCode)
  return request({
    url: '/BackendUploadEstBrochure',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getBackendEstBrochure(params) {
  return request({
    url: '/GetBackendEstBrochure',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 908,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Origin: params.Origin,
        EstNo: params.EstNo
      }
    }
  })
}

export function backendPublishEstBrochure(params) {
  return request({
    url: '/BackendPublishEstBrochure',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 909,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        BrochureID: params.BrochureID
      }
    }
  })
}

export function getBackendEstBrochureByUserID(params) {
  return request({
    url: '/GetBackendEstBrochureByUserID',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 910,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        Origin: params.Origin,
        EstNo: params.EstNo
      }
    }
  })
}

export function addBeefCutsContentData(params) {
  return request({
    url: '/AddBeefCutsContentData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 911,
      MessageID: btcguid(),
      Data: {
        Origin: params.Origin,
        OriginEn: params.OriginEn,
        Company: params.Company,
        EstNo: params.EstNo,
        Cuts: params.Cuts,
        Order: params.Order
      }
    }
  })
}

export function getCutsComment(params) {
  return request({
    url: '/GetCutsComment',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 912,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        pageSize: params.PageSize,
        Origin: params.Origin,
        EstNo: params.EstNo,
        Cuts: params.Cuts
      }
    }
  })
}

export function getNameSpaceBackend(params) {
  return request({
    url: '/GetNameSpaceBackend',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 913,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        pageSize: params.PageSize,
        Name: params.Name
      }
    }
  })
}

export function addNameSpaceBackend(params) {
  return request({
    url: '/AddNameSpaceBackend',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 914,
      MessageID: btcguid(),
      Data: {
        Name: params.Name,
        Type: params.Type
      }
    }
  })
}

export function deleteNameSpaceBackend(params) {
  return request({
    url: '/DeleteNameSpaceBackend',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 915,
      MessageID: btcguid(),
      Data: {
        NameSpaceID: params.NameSpaceID
      }
    }
  })
}

export function setDefaultCutsBrochure(params) {
  return request({
    url: '/SetDefaultCutsBrochure',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 916,
      MessageID: btcguid(),
      Data: {
        EstNo: params.EstNo,
        Origin: params.Origin,
        BrochureID: params.BrochureID
      }
    }
  })
}

export function backendDeleteEstBrochure(params) {
  return request({
    url: '/BackendDeleteEstBrochure',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 917,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        BrochureID: params.BrochureID
      }
    }
  })
}

export function uploadBackgroundCirclePicture(params) {
  const formData = new FormData()
  formData.append('MessageType', 918)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('UserID', params.UserID)
  return request({
    url: '/UploadBackgroundCirclePicture',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function addBeefBackgroundCutsContent(params) {
  return request({
    url: '/AddBeefBackgroundCutsContent',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 919,
      MessageID: btcguid(),
      Data: {
        Content: params.Content,
        Origin: params.Origin,
        EstNo: params.EstNo,
        Cuts: params.Cuts,
        UserID: params.UserID,
        CutsCode: params.CutsCode,
        EstNoCode: params.EstNoCode,
        Company: params.Company,
        IsTop: params.IsTop,
        IsAnonymous: params.IsAnonymous,
        PictureAddress: params.PictureAddress
      }
    }
  })
}

export function getBackgroundCutsComment(params) {
  return request({
    url: '/GetBackgroundCutsComment',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 920,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        pageSize: params.PageSize,
        Origin: params.Origin,
        UserID: params.UserID,
        EstNo: params.EstNo,
        Cuts: params.Cuts
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/cuts.js